//@ts-nocheck
const paths = {
  front: {
    home: "/",
    notFound: "/404",
    missingPermissions: "/403",
    login: "/login",
    forgotPassword: "/forgot-password",
    setPassword: "/set-password",
    sso: "/sso/auth",
    tabs: {
      analysis: "/analysis",
      custom_analysis: "/custom-analysis",
      flow: "/flow",
      indicators: "/indicators",
      live: "/live",
      login: "/login",
      non_moving_cars: "/non-moving-cars",
      park_stats: "/park-statistics",
      pedestrian_stats: "/pedestrian-statistics",
      visitor_characteristics: "/visitor-characteristics",
      config_sectors: "/config-sectors",
      displays: "/displays",
      alerts: "/alerts",
      gates: "/gates",
    },
  },
  api: {
    custom_analysis: {
      dataByAreas: {
        attendance: "/areas/stats/graph/attendance",
        attendanceStats: "/areas/stats/picker/attendance_stats",
        pressure: "/areas/stats/graph/pressure",
        attendancePeak: "/areas/stats/graph/attendance_peak",
        hourlyAttendance: "/areas/stats/graph/duration",
      },
    },
    visitor_characteristics: {
      dataByAreas: {
        visitorStats: "/qualification/indicators",
        visitors: "/qualification/visitors",
        categorizeVisitors: "/qualification/categorize-visitors",
        timeSpent: "/qualification/time",
        destinations: "/qualification/destinations",
      },
      dataByRadius: {
        catchmentAreas: "/qualification/catchment-areas",
      },
    },
    layers: {
      infos: {
        areas: "/areas",
        points: "/points",
        paths: "/paths",
      },
    },
    users: {
      contracts: "/users/contracts",
      setPassword: "/users/set_password",
      forgotPassword: "/users/forgot_password",
      config: {
        contracts: "/users/config",
        map: "/users/config/map/:id",
      },
      backoffice: {
        settings: "/users/backoffice/settings/:id",
      },
    },
    parkStatistics: {
      dataByRadius: {
        parkedCars: "/geo/park/data/parked_cars",
        availableParking: "/geo/park/data/available_parking",
        nonMovingCars: "/geo/park/data/non_moving_cars",
        heatmapOccupancy: "/geo/park/data/heatmap_occupancy",
        general: "/geo/park/stats/general",
        controls: "/geo/park/stats/controls",
        dailyAttendance: "/geo/park/stats/daily_attendance",
      },
      dataByAreas: {
        parkedCars: "/areas/park/data/parked_cars",
        availableParking: "/areas/park/data/available_parking",
        nonMovingCars: "/areas/park/data/non_moving_cars",
        general: "/areas/park/stats/general",
        controls: "/areas/park/stats/controls",
        dailyAttendance: "/areas/park/stats/daily_attendance",
        details: "/areas/park/stats/details",
        occupancy: "/areas/occupancy",
      },
      lock: "/areas/park/lock",
      all: "/areas/park/all",
    },
    iot: {
      displays: {
        general: "/iot/displays",
        udpdateStandBy: "/iot/displays/:id/stand_by",
        udpdateRule: "/iot/displays/:id/rule",
        updateEmergencyRule: "/iot/displays/:id/emergency_rule",
      },
    },
    pedestrianStatistics: {
      dataByAreas: {
        general: "/areas/pedestrian/stats/general",
        dailyAttendance: "/areas/pedestrian/stats/daily_attendance",
        details: "/areas/pedestrian/stats/details",
        queueDetailsStats: "/areas/pedestrian/queue/stats/details",
        queueDailyAttendance: "/areas/pedestrian/queue/stats/daily_attendance",
        queueDailyAttendanceMax:
          "/areas/pedestrian/queue/stats/daily_attendance_max",
        queueWaitingTime: "/areas/pedestrian/queue/stats/daily_waiting",
      },
    },
    reports: { list: "/reports" },
    flow: {
      stats: {
        area: {
          general: "/flows/stats/area/:id",
          details: "/flows/stats/area/:id/details",
          graph: {
            attendance: "/flows/stats/area/:id/graph/attendance",
            chronology: "/flows/stats/area/:id/graph/chronology",
          },
        },
        point: {
          general: "/flows/stats/point/:id",
          details: "/flows/stats/point/:id/details",
          graph: {
            chronology: "/flows/stats/point/:id/graph/chronology",
            attendance: "/flows/stats/point/:id/graph/attendance",
          },
        },
        path: {
          general: "/flows/stats/path/:id",
          distribution: "/flows/stats/path/:id/distribution",
          graph: {
            travelTime: "/flows/stats/path/:id/graph/travel_time",
          },
        },
        traffic: {
          at: "/flows/stats/traffic/:id/at",
          general: "/flows/stats/traffic/:id",
          graph: {
            chronology: "/flows/stats/traffic/:id/graph/chronology",
          },
        },
      },
    },
    config: {
      sectors: {
        general: "/areas/sectors",
        data: "/areas/sectors/data",
        update: "/areas/sectors/:id",
      },
    },
    indicators: {
      default: "/indicators",
      download: "/indicators/download",
    },
    alertFactory: {
      alertEvents: "/alert-factory/alert-events",
      alertEventsViewer: "/alert-factory/alert-events/viewer",
      alertPolicies: "/alert-factory/alert-policies",
      manageOutputs: "/alert-factory/alert-policies/manage-outputs",
    },
    gates: {
      automaticSystems: "/gates/automatic_systems",
      automaticSystemsDetails: "/gates/automatic_systems/:id",
      updateAutomaticSystemsMode: "/gates/automatic_systems/:id/mode",
      updateAutomaticSystemsStatus: "/gates/automatic_systems/:id/status",
    },
  },
};

export default paths;
